import { AwsFacade, IsSignedInResults } from 'src/facade/aws/AwsFacade';

export async function isSignedIn(): Promise<boolean> {
    const result = await AwsFacade.isSignedIn(true);
    return result === IsSignedInResults.SIGNED_IN;
}
